const ADMIN_HOST_REGEX = /^admin\./i;
const LOCAL_HOST_REGEX = /^(localhost|127\.0\.0\.1)$/i;

export const getPortalMode = () => {
  const forcedMode = (process.env.REACT_APP_PORTAL_TARGET || '').trim().toLowerCase();
  if (['admin', 'customer', 'both'].includes(forcedMode)) {
    return forcedMode;
  }

  if (typeof window === 'undefined') {
    return 'customer';
  }

  const host = (window.location.hostname || '').toLowerCase();
  if (ADMIN_HOST_REGEX.test(host)) {
    return 'admin';
  }

  if (LOCAL_HOST_REGEX.test(host)) {
    return 'both';
  }

  return 'customer';
};

export const isAdminPortal = () => getPortalMode() === 'admin';
export const isCustomerPortal = () => getPortalMode() === 'customer';
